<template>
    <span>{{ info.agrm_type==2?'Согласие':'Договор' }} №: <span v-if="info.agrm_number">{{ info.agrm_number }}</span><span v-if="dates && info.agrm_date_begin>'' && info.agrm_date_begin!='0000-00-00 00:00:00' && info.agrm_date_begin!='0000-00-00'"> (с {{ $GVO.convertDateTimeFromMysqlToDate(info.agrm_date_begin) }} по {{ $GVO.convertDateTimeFromMysqlToDate(info.agrm_date_end) }})</span></span>
</template>
<script>
export default {
	name: 'ReAgrmInfo',
    props:{
        info:{
            type: Object,
            default(){ return {}}
        },
        dates:{
            type: Boolean,
            default: true,
        }
    }
}
</script>
